<div class="modal-body">
  <div class="position-relative">
    <div class="logo-container">
      <img src="assets/images/simple-logo-msd.png" alt="logo">
    </div>
    <div class="main-container">
      <div class="left-side">
        <img src="assets/images/ressource-bienvenue.jpg">
      </div>
      <div class="right-side">
        <h1 class="valid">RESSOURCES</h1>
        <p>L'espace "Ressources" est réservé aux abonnés MonSuiviDiet.</p>
        <p>Il regroupe : </p>
        <ul>
          <li>Masterclass gratuites</li>
          <li>Modèle de trame de consultation</li>
          <li>Affiche pour la salle d'attente</li>
          <li>Questionnaires patients</li>
        </ul>
      </div>
    </div>
  </div>
</div>
